// extracted by mini-css-extract-plugin
export default {"container":"EditButton_container__8Jwy3"};